<mat-chip-set>
    <!-- TODO: SHOW DOCUMENT EMPLOYER STATE -->
    <!-- Show Archivar-->
    <mat-basic-chip disabled class="unseen" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="this.item?.isArchiveSequence() && !(this.item?.isCanceled())">
        <mat-icon  fontSet="fa" fontIcon="fa-archive">
        </mat-icon>
        <span>{{'common.filedDocumentLbl' | transloco}}</span>
    </mat-basic-chip>

    <!-- Show Pendiente de Firmar Firmante-->
    <mat-basic-chip disabled class="not-signed-employer" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) && !(this.item?.isEmployerViewPending()) && this.item?.isEmployerActionPending() && !(this.item?.isCanceled())">
        <mat-icon  fontSet="fa" fontIcon="fa-signature">
        </mat-icon>
        <span>{{'common.unsignedBySignerLbl' | transloco}}</span>
    </mat-basic-chip>

    <!-- Show firmado sin estado Empleado -->
    <mat-basic-chip disabled class="signed-ok" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) &&  this.item?.employeeStateClass === 'firmado'  && !(this.item?.isEmployerActionPending()) && !(this.item?.isCanceled())"
        matTooltip="{{'common.SignedOnLbl' | transloco}} {{this.item?.EmployeeSignatureDate() | date :'dd/MM/yyyy'}}">
        <mat-icon  fontSet="fa" fontIcon="fa-smile">
        </mat-icon>
        <span *ngIf="this.showSmallChips">{{'common.signedLbl' | transloco}}</span>
        <span *ngIf="!this.showSmallChips">{{'common.signedLbl' | transloco}}:
      {{this.item?.EmployeeSignatureDate() | date :'dd/MM/yyyy'}}</span>
    </mat-basic-chip>

    <!-- Show firmado conforme Empleado -->
    <mat-basic-chip disabled class="signed-ok" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) &&  this.item?.employeeStateClass === 'firmado-conforme'  && !(this.item?.isEmployerActionPending())"
        [matTooltip]="'fileDocuments.fileDocumentState.signedInAgreementOnTooltip' | transloco: { date: (this.item?.EmployeeSignatureDate() | date :'dd/MM/yyyy') }">
        <mat-icon  fontSet="fa" fontIcon="fa-smile">
        </mat-icon>
        <span *ngIf="this.showSmallChips">{{'common.inAgreementLbl' | transloco}}</span>
        <span *ngIf="!this.showSmallChips">{{'common.signedInAgreementLbl' | transloco}}:
      {{this.item?.EmployeeSignatureDate() | date :'dd/MM/yyyy'}}
    </span>
    </mat-basic-chip>

    <!-- Show firmado no-conforme Empleado -->
    <mat-basic-chip disabled class="signed-not-ok" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) &&  this.item?.employeeStateClass === 'firmado-no-conforme'  && !(this.item?.isEmployerActionPending())"
        [matTooltip]="'fileDocuments.fileDocumentState.signedInDisagreementOnTooltip' | transloco: { date: (this.item?.EmployeeSignatureDate() | date :'dd/MM/yyyy') }">
        <mat-icon  fontSet="fa" fontIcon="fa-frown">
        </mat-icon>
        <span *ngIf="this.showSmallChips">{{'common.inDisagreementLbl' | transloco}}</span>
        <span *ngIf="!this.showSmallChips">{{'common.signedInDisagreementLbl' | transloco}}:
      {{this.item?.EmployeeSignatureDate() | date :'dd/MM/yyyy'}}
      <span *ngIf="this.item?.employeeDocumentSignData?.motiveDisagreement" id='motiveDisagreement'> -
        {{this.item?.employeeDocumentSignData?.motiveDisagreement}}</span>
        </span>
    </mat-basic-chip>

    <!-- Chip de Consultas  -->
    <mat-basic-chip disabled class="chat-chip" [class.thread-open]="!this.item?.threadClosed" [class.thread-closed]="this.item?.threadClosed" fxLayout="row" fxLayoutAlign="center center" *ngIf="this.useDocComments && this.item?.hasMessage" [matTooltip]="this.item?.threadClosed ? ('fileDocuments.fileDocumentState.queryClosedTooltip' | transloco) : ('fileDocuments.fileDocumentState.queryOpenTooltip' | transloco)">
      <div class="chat-icon-container">
        <mat-icon fontSet="fa" fontIcon="fa-comment"></mat-icon>
        <span *ngIf="!this.item?.threadClosed" class="status-dot-badge"></span>
      </div>
    </mat-basic-chip>

    <!-- Show pendiente de firmar Empleado -->
    <mat-basic-chip disabled class="not-signed" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" [matTooltip]="'fileDocuments.fileDocumentState.readyToSignTooltip' | transloco" *ngIf="!(this.item?.isArchiveSequence()) && this.item?.employeeStateClass === 'no-firmado' && this.item?.isEmployeeActionPending()  && !(this.item?.isEmployerActionPending()) && !this.item?.isUploadPending() && !(this.item?.isCanceled())">
        <mat-icon  fontSet="fa" fontIcon="fa-signature">
        </mat-icon>
        <span>{{'common.unsignedLbl' | transloco}}</span>
    </mat-basic-chip>

    <!-- Show pendiente de subida Empleado -->
    <mat-basic-chip disabled class="not-signed" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" [matTooltip]="'fileDocuments.fileDocumentState.readyToAttachTooltip' | transloco" *ngIf="this.item?.isUploadPending() && !(this.item?.isCanceled())">
        <mat-icon  fontSet="fa" fontIcon="fa-paperclip">
        </mat-icon>
        <span>{{'common.noAttachmentLbl' | transloco}}</span>
    </mat-basic-chip>

     <!-- Show No visto por Empleado -->
     <mat-basic-chip disabled class="unseen" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) && this.item?.isEmployeeViewPending() && !(this.item?.isEmployerActionPending()) && !(this.item?.isCanceled())">
      <mat-icon  fontSet="fa" fontIcon="fa-eye-slash">
      </mat-icon>
      <span>{{'common.notSeenLbl' | transloco}}</span>
  </mat-basic-chip>

  <!-- Show visto por Empleado -->
  <!-- eslint-disable-next-line @angular-eslint/template/eqeqeq -->
  <mat-basic-chip disabled class="seen" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) &&  !this.item?.isEmployeeViewPending()  && !(this.item?.isEmployerActionPending()) && !(this.item?.isCanceled()) && this.sign==undefined"
      matTooltip="{{this.item?.EmployeeViewedDate() | date :'dd/MM/yyyy'}}">
      <mat-icon  fontSet="fa" fontIcon="fa-eye">
      </mat-icon>
      <span *ngIf="this.showSmallChips">{{'common.seenLbl' | transloco}}</span>
      <span *ngIf="!this.showSmallChips">{{'common.seenLbl' | transloco}}:
    {{this.item?.EmployeeViewedDate() | date :'dd/MM/yyyy'}}</span>
  </mat-basic-chip>

  <!-- Show Documento cancelado -->
  <mat-basic-chip disabled class="signed-ok cancelled" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="this.item?.isCanceled()" [matTooltip]="'common.rejectedLbl' | transloco">
    <mat-icon  fontSet="fa" fontIcon="fa-times-circle">
    </mat-icon>
    <span>{{'common.rejectedLbl' | transloco}}</span>
</mat-basic-chip>

<!-- Show Pendiente de Ver Firmante-->
<mat-basic-chip disabled class="unseen-employer" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="!(this.item?.isArchiveSequence()) && this.item?.isEmployerViewPending() && !(this.item?.isCanceled())">
    <mat-icon  fontSet="fa" fontIcon="fa-eye-slash">
    </mat-icon>
    <span>{{'common.notSeenSignerLbl' | transloco}}</span>
</mat-basic-chip>

<button
  mat-stroked-button
  class="nom151-evidence-button"
  type="button"
  (click)="verEvidenciasdeFirmas(this.item)"
  *ngIf="this.item?.documentFileSignaturesData?.length > 0 && this.item.documentFileSignaturesData[0]?.proveDocumentId != null"
  [matTooltip]="'fileDocuments.fileDocumentDetail.viewNom151EvidenceTooltip' | transloco"
  [attr.aria-label]="'fileDocuments.fileDocumentDetail.viewNom151EvidenceTooltip' | transloco">
  <mat-icon fontSet="fa" fontIcon="fa-file-certificate"></mat-icon>
  <span>{{ 'fileDocuments.fileDocumentDetail.nom151EvidenceBtn' | transloco }}</span>
</button>

   <!-- Show evidencia Empleado -->
   <mat-basic-chip disabled class="signed-ok" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" *ngIf="this.sign?.signedBy === 'Empleado'"
   matTooltip="{{'common.SignedOnLbl' | transloco}} {{this.sign?.signedDate | date :'dd/MM/yyyy'}}">
   <mat-icon  fontSet="fa" fontIcon="fa-smile">
   </mat-icon>
   <span>{{'common.signedLbl' | transloco}}  {{this.sign?.signedDate | date :'dd/MM/yyyy'}}
</span>
</mat-basic-chip>

<mat-basic-chip disabled  fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="4px" matTooltip="{{'common.SignedOnLbl' | transloco}} {{this.sign?.signedDate | date :'dd/MM/yyyy'}}" *ngIf="this.sign?.signedBy === 'Firmante'">
  <mat-icon  fontSet="fa" fontIcon="fa-check">
  </mat-icon>
  <span>{{'common.SignedOnLbl' | transloco}} {{this.sign?.signedDate | date :'dd/MM/yyyy'}}</span>
</mat-basic-chip>

</mat-chip-set>
